import { render, staticRenderFns } from "./InAppStorePage.vue?vue&type=template&id=6467e520&scoped=true"
import script from "./InAppStorePage.vue?vue&type=script&lang=js"
export * from "./InAppStorePage.vue?vue&type=script&lang=js"
import style0 from "./InAppStorePage.vue?vue&type=style&index=0&id=6467e520&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467e520",
  null
  
)

export default component.exports